import { render, staticRenderFns } from "./ModalWithDynamicWidth.vue?vue&type=template&id=bd81c24e"
import script from "./ModalWithDynamicWidth.vue?vue&type=script&lang=js"
export * from "./ModalWithDynamicWidth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports